<div class="content-box-body">
  <div class="p-3 border-bottom d-flex align-items-center">
    <div>
      <h6 class="mb-0" i18n>Preferences</h6>
      <div class="text-light" i18n>Select which notifications you would like to receive.</div>
    </div>
    <div class="flex-fill"></div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field2 class="mat-block m-4 pr-4">
        <input type="text"
               matInput
               i18n-placeholder
               placeholder="Sender Name"
               [formControl]="form.get('sender_name')" />
        <mat-error *ngIf="form.get('sender_name').touched && form.get('sender_name').hasError('minlength')"
                   i18n>
          Name must be at least 2 characters long
        </mat-error>
        <mat-error *ngIf="form.get('sender_name').touched && form.get('sender_name').hasError('maxlength')"
                   i18n>
          Name must be at most 30 characters long
        </mat-error>
        <mat-hint align="end">{{ form.get('sender_name').value.length || 0 }}/30</mat-hint>
      </mat-form-field2>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6 border-right">
      <div class="card my-4 mr-2 ml-4 bg-card">
        <div class="p-3 border-bottom d-flex align-items-center gap-3">
          <h6 class="mb-0" i18n>Signer Notifications</h6>
          <div class="flex-fill"></div>
        </div>
        <div class="p-3">
          <app-document-signer-notifications [form]="form.get('signer')"></app-document-signer-notifications>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="my-4 mr-4 ml-2">
        <div class="card bg-card">
          <div class="p-3 border-bottom d-flex align-items-center gap-3">
            <h6 class="mb-0" i18n>User Notifications</h6>
            <div class="flex-fill"></div>
          </div>
          <div class="p-3">
            <app-document-user-notifications
              [form]="form.get('sender')"
              [receiverForm]="reminderForm"
            ></app-document-user-notifications>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
